<template>
  <el-dialog
    title="视频上传"
    width="600px"
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="onClose"
    @keyup.enter.native="onSubmit()">
    <el-form ref="form"
             :model="form"
             :rules="rules"
             size="small"
             label-width="70px"
             style="padding-right: 50px;margin-bottom: -20px;">
      <el-form-item label="视频"
                    prop="file">
        <el-upload
          ref="video"
          action=""
          accept=".mp4"
          :file-list="videoList"
          :auto-upload="false"
          :on-change="changeVideo">
          <el-button size="small"
                     type="primary">点击上传
          </el-button>
          <div slot="tip"
               class="el-upload__tip">只能上传mp4文件，且不超过50MB
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="封面"
                    prop="poster">
        <el-upload
          ref="poster"
          action=""
          accept=".jpg,.jpeg,.png,.gif"
          :file-list="posterList"
          :auto-upload="false"
          :on-change="changePoster">
          <el-button size="small"
                     type="primary">点击上传
          </el-button>
          <div slot="tip"
               class="el-upload__tip">只能上传jpg/png/gif文件，且不超过2MB
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleAction('cancel')">取 消</el-button>
      <el-button type="primary"
                 @click="onSubmit()"
                 :disabled="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {},
  data () {
    return {
      visible: false,
      action: '',
      title: undefined,
      loading: false,
      rules: {
        file: [{
          message: '请选择视频文件',
          type: 'object',
          required: true
        }, {
          type: 'object',
          required: true,
          validator: (rule, value, callback) => {
            const size = 50
            if (value.size / 1024 / 1024 < size) {
              return callback()
            }
            return callback(new Error(`视频文件不能超过${size}MB`))
          }
        }],
        poster: [{
          message: '请选择视频封面文件',
          type: 'object',
          required: true
        }, {
          type: 'object',
          required: true,
          validator: (rule, value, callback) => {
            const size = 5
            if (value.size / 1024 / 1024 < size) {
              return callback()
            }
            return callback(new Error(`视频封面文件不能超过${size}MB`))
          }
        }],
      },
      form: {
        file: '',
        poster: '',
      },
      videoList: [],
      posterList: [],
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    handleAction (action) {
      this.action = action
      this.doClose()
    },
    onClose () {
      if (!this.visible) return
      this.handleAction('close')
    },
    doClose () {
      if (!this.visible) return
      this.visible = false
      setTimeout(() => {
        if (this.action) this.callback(this.action, _.clone(this.form))
        this.resetFields()
      })
    },
    resetFields () {
      this.$refs.video.clearFiles()
      this.$refs.poster.clearFiles()
      Object.assign(this.$data.form, this.$options.data.call(this).form)
      this.$refs.form.resetFields()
    },
    onSubmit () {
      this.$refs.form.validate().then(() => {
        this.handleAction('confirm')
      }).catch(() => {
        this.$message.error('提交内容填写不正确！')
      })
    },
    changeVideo (file) {
      if (file) {
        this.videoList = [file]
        this.form.file = file.raw
      } else {
        this.videoList = []
        this.form.file = null
      }
    },
    changePoster (file) {
      if (file) {
        this.posterList = [file]
        this.form.poster = file.raw
      } else {
        this.posterList = []
        this.form.poster = null
      }
    },
    validate (file) {
      const size = 50
      const isLtSize = this.form.file.size / 1024 / 1024 < size
      if (!isLtSize) {
        this.$message.error(`上传视频大小不能超过 ${size}MB!`)
      }
      return isLtSize
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-upload-video-box/src/main.vue